import { TicketingOwnerRef } from '@packages/types';

const ADMIN_URL = (import.meta.env.VITE_ADMIN_URL || 'https://wuest-und-wild-admin.web.app').replace(
  /\/$/,
  '',
);

const checkinPathForOwner = (owner: TicketingOwnerRef | undefined, ticketId: string) => {
  const encodedTicketId = encodeURIComponent(ticketId);

  if (owner?.kind === 'event') {
    return `/events/${encodeURIComponent(owner.eventId)}/checkin/${encodedTicketId}`;
  }

  if (owner?.kind === 'festivalEdition') {
    return `/festival-editions/${encodeURIComponent(owner.festivalEditionId)}/checkin/${encodedTicketId}`;
  }

  return `/festival-checkin/${encodedTicketId}`;
};

export const getAdminCheckinUrl = (owner: TicketingOwnerRef | undefined, ticketId: string) =>
  `${ADMIN_URL}${checkinPathForOwner(owner, ticketId)}`;
